export default __webpack_public_path__ + "static/media/pic7.e9c2fb42.jpg";